import { doLogin } from "../data/apiClient";

export const authRepository = {
    doLogin: async (credentials) => {
        try {
            const response = await doLogin(credentials);
            const { token, exp, user } = response.data;
            return { success: true, session: { name: user, token, exp } };
        } catch (error) {
            if (error.response && error.response.status === 401) {
                return { success: false, message: 'Invalid username or password' };
            } else {
                return { success: false, message: 'An unexpected error occurred' };
            }
        }
    },
}